import React from 'react'
import '../../../assets/styles/normal-to-premium.scss'
import { ApplyPcContent, ErrorPopup, Footer, ServiceList, SuccessPopupWithDownloadApp, TermsPopup } from '../../common'
import {
  ApplicationHeader,
  BankAccountWrap,
  BizNoField,
  BizNoTypeField,
  ConfirmPasswordField,
  IdField,
  OwnerNameField,
  OwnerPhoneNoField,
  PasswordField,
  ShopNameField,
  SubmitWrap,
  TermsWrap
} from './local-components/ApplicationComponents'
import useApplicationForm from './useApplicationForm'

const CustomerWrap = props => (
  <div className="customer_wrap">
    <p className="wrap_tit">
      사업자 정보<span className="color_r">*</span>
    </p>
    <BizNoTypeField {...props} />
    <BizNoField
      register={props.register}
      bizNoHelper={props.bizNoHelper}
      isBiznoValid={props.isBiznoValid}
      getApplyBizNoValid={props.getApplyBizNoValid}
      onChangeBizNo={props.onChangeBizNo}
      errors={props.errors}
      isDisabled={true}
    />
    <ShopNameField {...props}></ShopNameField>
    <OwnerNameField {...props}></OwnerNameField>
    <OwnerPhoneNoField {...props} />

    <IdField
      shop_idx={props.param.shop_idx}
      shopId={props.shopId}
      reSignup={props.reSignup}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      idSetting={props.idSetting}
      errors={props.errors}
      isNormal2Premium={props.isNormal2Premium}></IdField>
    <PasswordField
      shop_idx={props.param.shop_idx}
      shopPassword={props.shopPassword}
      reSignup={props.reSignup}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      passwordSetting={props.passwordSetting}
      errors={props.errors}
      isNormal2Premium={props.isNormal2Premium}></PasswordField>
    <ConfirmPasswordField
      shop_idx={props.param.shop_idx}
      shopConfirmPassword={props.shopConfirmPassword}
      reSignup={props.reSignup}
      register={props.register}
      bizNoTrue={props.bizNoTrue}
      confirmPassword={props.confirmPassword}
      errors={props.errors}
      isNormal2Premium={props.isNormal2Premium}></ConfirmPasswordField>
  </div>
)

const ApplicationNormal2Premium = () => {
  const af = useApplicationForm({
    isNormal2Premium: true
  })
  const {
    location,
    param,
    formRef,
    different_customer_sign_ref,
    different_account_sign_ref,
    managerName,
    serviceNum,
    setServiceNum,
    setServiceInfo,
    serviceInfo,
    serviceBoxInputEvh,
    serviceHelper,
    setServiceHelper,
    cost,
    setCost,
    successPopupState,
    errorPopupState,
    setErrorPopupState,
    errorPopupMessage,
    btnState,
    serviceStartDt,
    setServiceStartDt,
    withdrawalDt,
    setWithdrawalDt,
    shopId,
    shopPassword,
    shopConfirmPassword,
    reSignup,

    selectList,
    differentCustomerIsSigned,
    setDifferentCustomerIsSigned,
    differentCustomerHelper,
    setDifferentCustomerHelper,
    differentAccountIsSigned,
    setDifferentAccountIsSigned,
    differentAccountHelper,
    setDifferentAccountHelper,
    register,
    handleSubmit,
    bizNoTrue,
    freeMonthYn,
    bizNoHelper,
    bizNo,
    isBiznoValid,
    getApplyBizNoValid,
    onChangeBizNo,
    onSubmit,
    ownerNameSetting,
    ownerPhoneNoSetting,
    accountNameSetting,
    idSetting,
    passwordSetting,
    confirmPassword,
    diffApplyCustomerCheck,
    differentApplyCustomerCheck,
    differentAccountCheck,
    termsPopupOpen,
    termsPopupClose,
    errors,
    isNormal2Premium
  } = af
  return (
    <div className="Application SubPages">
      <div className="application_wrap normal-to-premium">
        <ApplyPcContent /> {/* 1024 이상 display */}
        <div className={successPopupState || errorPopupState ? 'application_sheet notScroll' : 'application_sheet 2'} ref={formRef}>
          <ApplicationHeader location={location} managerName={managerName} {...af} />
          <form className="application_form_wrap" onSubmit={handleSubmit(onSubmit)}>
            <CustomerWrap
              param={param}
              shopId={shopId}
              shopPassword={shopPassword}
              shopConfirmPassword={shopConfirmPassword}
              reSignup={reSignup}
              register={register}
              bizNoTrue={bizNoTrue}
              bizNoHelper={bizNoHelper}
              isBiznoValid={isBiznoValid}
              getApplyBizNoValid={getApplyBizNoValid}
              onChangeBizNo={onChangeBizNo}
              ownerNameSetting={ownerNameSetting}
              ownerPhoneNoSetting={ownerPhoneNoSetting}
              idSetting={idSetting}
              passwordSetting={passwordSetting}
              confirmPassword={confirmPassword}
              errors={errors}
              isNormal2Premium={isNormal2Premium}></CustomerWrap>

            <ServiceList
              register={register}
              cost={cost}
              freeMonthYn={freeMonthYn}
              serviceBoxInputEvh={serviceBoxInputEvh}
              serviceInfo={serviceInfo}
              setServiceInfo={setServiceInfo}
              setServiceHelper={setServiceHelper}
              serviceHelper={serviceHelper}
              setCost={setCost}
              serviceNum={serviceNum}
              setServiceNum={setServiceNum}
              setServiceStartDt={setServiceStartDt}
              setWithdrawalDt={setWithdrawalDt}
              withdrawalDt={withdrawalDt}
              serviceStartDt={serviceStartDt}
              bizNo={bizNo}
              isNormal2Premium={isNormal2Premium}
            />

            <BankAccountWrap
              bank_code={selectList.bank_code}
              register={register}
              bizNoTrue={bizNoTrue}
              accountNameSetting={accountNameSetting}
              errors={errors}
            />

            <TermsWrap
              different_customer_sign_ref={different_customer_sign_ref}
              different_account_sign_ref={different_account_sign_ref}
              differentCustomerIsSigned={differentCustomerIsSigned}
              setDifferentCustomerIsSigned={setDifferentCustomerIsSigned}
              differentCustomerHelper={differentCustomerHelper}
              setDifferentCustomerHelper={setDifferentCustomerHelper}
              differentAccountIsSigned={differentAccountIsSigned}
              setDifferentAccountIsSigned={setDifferentAccountIsSigned}
              differentAccountHelper={differentAccountHelper}
              setDifferentAccountHelper={setDifferentAccountHelper}
              register={register}
              diffApplyCustomerCheck={diffApplyCustomerCheck}
              differentApplyCustomerCheck={differentApplyCustomerCheck}
              differentAccountCheck={differentAccountCheck}
              termsPopupOpen={termsPopupOpen}
              errors={errors}
            />

            <SubmitWrap btnState={btnState} serviceStartDt={serviceStartDt} withdrawalDt={withdrawalDt} />
          </form>

          {/* 푸터내용 */}
          <Footer />

          {/* 약관 성공 팝업 TODO 캡쳐 파라미터 미사용, 삭제해야함 */}
          <TermsPopup termsPopupClose={termsPopupClose} capture={false} />

          {/* 신청 성공 팝업 */}
          <SuccessPopupWithDownloadApp open={successPopupState} />
          {/* 신청 오류 팝업 */}
          <ErrorPopup open={errorPopupState} setErrorPopupState={setErrorPopupState} errorPopupMessage={errorPopupMessage} />
        </div>
      </div>
    </div>
  )
}

export { ApplicationNormal2Premium }
